import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {
    const formInitialDetails = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    };

    const [formDetails, setFormDetails] = useState(formInitialDetails);
    const [buttonText, setButtonText] = useState('Send');
    const [status, setStatus] = useState(null);

    // Fonction pour mettre à jour les champs
    const onFormUpdate = (category, value) => {
        setFormDetails({
            ...formDetails,
            [category]: value
        });
    };

    // Fonction pour gérer la soumission du formulaire
    const handleSubmit = async (event) => {
        event.preventDefault();

        setButtonText("Sending...");

        try {
            const response = await fetch('https://portfolio-server-nine-zeta.vercel.app/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formDetails), // Utilisez formDetails ici
            });

            if (!response.ok) {
                // Si le serveur retourne une erreur
                const errorMessage = await response.text();
                setStatus({ success: false, message: errorMessage });
            } else {
                const successMessage = await response.text();
                setStatus({ success: true, message: successMessage });
                setFormDetails(formInitialDetails); // Réinitialisez le formulaire après succès
            }
        } catch (error) {
            console.error('Erreur lors de l\'envoi du formulaire :', error);
            setStatus({ success: false, message: 'Une erreur est survenue. Veuillez réessayer.' });
        } finally {
            setButtonText("Send");
        }
    };



    return (
        <section className="contact" id="connect">
            <Container>
                <Row className="align-items-center">
                    <Col size={12} md={6}>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us" />
                            }
                        </TrackVisibility>
                    </Col>
                    <Col size={12} md={6}>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                                    <h2>Get In Touch</h2>
                                    <form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col size={12} sm={6} className="px-1">
                                                <input
                                                    type="text"
                                                    value={formDetails.firstName}
                                                    placeholder="First Name"
                                                    onChange={(e) => onFormUpdate('firstName', e.target.value)}
                                                />
                                            </Col>
                                            <Col size={12} sm={6} className="px-1">
                                                <input
                                                    type="text"
                                                    value={formDetails.lastName}
                                                    placeholder="Last Name"
                                                    onChange={(e) => onFormUpdate('lastName', e.target.value)}
                                                />
                                            </Col>
                                            <Col size={12} sm={6} className="px-1">
                                                <input
                                                    type="email"
                                                    value={formDetails.email}
                                                    placeholder="Email Address"
                                                    onChange={(e) => onFormUpdate('email', e.target.value)}
                                                />
                                            </Col>
                                            <Col size={12} sm={6} className="px-1">
                                                <input
                                                    type="tel"
                                                    value={formDetails.phone}
                                                    placeholder="Phone No."
                                                    onChange={(e) => onFormUpdate('phone', e.target.value)}
                                                />
                                            </Col>
                                            <Col size={12} className="px-1">
                                                <textarea
                                                    rows="6"
                                                    value={formDetails.message}
                                                    placeholder="Message"
                                                    onChange={(e) => onFormUpdate('message', e.target.value)}
                                                ></textarea>
                                                <button type="submit" disabled={buttonText === "Sending..."}><span>{buttonText}</span></button>
                                            </Col>
                                            {
                                                status &&
                                                <Col>
                                                    <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                                                </Col>
                                            }
                                        </Row>
                                    </form>
                                </div>
                            }
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
